import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { Flashcard } from 'src/app/models/flashcard.model';

@Component({
  selector: 'app-flashcard-list',
  templateUrl: './flashcard-list.component.html',
  styleUrls: ['./flashcard-list.component.scss'],
  standalone: false
})
export class FlashcardListComponent {

  @Input() flashcards!: Flashcard[];
  @Output() flashcardsChange: EventEmitter<Flashcard[]> = new EventEmitter<Flashcard[]>();
  @Input() hideDueDate: boolean = false;

  constructor(
    private flashcardService: FlashcardService
  ) {}

  ngOnInit() {}

  handleActionClicked(action: any, flashcard: Flashcard) {
    if (action === 'delete') {
      this.flashcardService.deleteFlashcard(flashcard.id!).subscribe(() => {
        this.flashcards.splice(this.flashcards.indexOf(flashcard), 1);
        this.flashcardsChange.emit(this.flashcards);
      });
    }
  }
}